
















import { defineComponent, computed, ref } from "@vue/composition-api";
import Icon from "./Icon.vue";
import { routerStore } from "@/store/routerStore";

export default defineComponent({
  components: {
    Icon
  },
  setup() {
    const forward = ref<Array<string>>([]);
    const folderName = computed(() => {
      const short = routerStore.pwd.split("/").slice(-1)[0];
      return `搜索"${short || "此电脑"}"`;
    });
    const backable = computed(()=>routerStore.getState().history.length)
    const forwardable = computed(() => forward.value.length > 0);
    const upable = computed(() => routerStore.pwd !== "/");
    return {
      pwd: computed(()=>routerStore.pwd),
      backable,
      folderName,
      forwardable,
      upable,
      goback: () => {
        forward.value.push(routerStore.pwd);
        routerStore.goBack();
      },
      goforward: () => {
        console.log(forward.value);
        if (forward.value.length > 0) {
          const path = forward.value.pop() || "/";
          routerStore.goto(path);
        }
      },
      upfolder: () => {
        const pwd = routerStore.pwd;
        if (pwd.split("/").length >= 2) {
          const newPath = pwd
            .split("/")
            .slice(0, -1)
            .join("/");
          routerStore.goto(newPath || "/");
        }
      }
    };
  }
});
